import { Box, CheckBox, ColorOptions, Icon, ModBox, Spacer, Text, TextInput } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { FlatList } from 'react-native'
import styles from './styles'

interface ModalViewProps {
  hide?: boolean
  onDismiss: () => void
  selectedData?: (values: any) => void
  measureInfo?: any
  data?: any
  preSelectedData?: any
  isMultiSelect?: boolean
  checkboxColor?: ColorOptions
  width?: number
  maxHeight?: number
  fontFamily?: string
  selectAll?: boolean
  testId?: string
}

const ModalView: FC<ModalViewProps> = ({
  hide,
  onDismiss,
  selectedData,
  measureInfo,
  data,
  preSelectedData = [],
  isMultiSelect = false,
  checkboxColor,
  width = 360,
  maxHeight,
  fontFamily,
  selectAll = false,
  testId,
}: ModalViewProps) => {
  const [selectionData, setSelectionData] = useState(preSelectedData as Array<string>)

  const [searchData, setSearchData] = useState(data)
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    setSelectionData(preSelectedData)
  }, [preSelectedData])

  useEffect(() => {
    setSearchData(data)
  }, [data])

  if (!hide) {
    return null
  }

  const handleCheckBox = (listItem: any) => {
    if (!isMultiSelect && selectedData) {
      selectedData([listItem.value])
      onDismiss()
      return
    }
    let inputInfoId = listItem.value
    let selectedArray = selectionData
    if (selectedArray?.includes(inputInfoId)) {
      var index = selectedArray.indexOf(inputInfoId)
      selectedArray.splice(index, 1)
    } else {
      selectedArray = selectedArray?.length === 0 ? [inputInfoId] : [...selectedArray, inputInfoId]
    }
    setSelectionData([...selectedArray])
    if (selectedData) {
      selectedData([...selectedArray])
    }
    setSearchText('')
  }

  const handleSelectAll = () => {
    let selectedArray = selectionData
    if (selectedArray?.length > 0 && selectedArray?.length === data?.length) {
      selectedArray = []
    } else {
      selectedArray = data?.map((item) => item?.value)
    }
    if (selectedData) {
      selectedData([...selectedArray])
    }
    setSearchText('')
  }
  const renderItem = ({ item, index }: { item: any; index: number }) => {
    const isChecked = selectionData?.includes(item?.value)
    return (
      <Box
        {...styles.itemView}
        onPress={() => handleCheckBox(item)}
        testID={`instrument-${item?.value}${index}`}
        w={width}>
        {isMultiSelect && (
          <>
            <CheckBox
              color={isChecked ? checkboxColor : 'BLACK_LIGHT'}
              checked={isChecked}
              onChange={() => handleCheckBox(item)}
              iconSize="FONT_SIZE_LARGE"
            />
            <Spacer direction="horizontal" size={8} />
          </>
        )}
        <Box flexWrap="wrap">
          <Text color="BLACK_21" fontFamily={fontFamily} fontSize={'FONT_SIZE_SMALLER'} title={item?.value} />
        </Box>
      </Box>
    )
  }
  const getKeyExtractor = (itemData: any, index: number): string => {
    return `${itemData?.fileName}_${index}`
  }

  const onChange = (value: any) => {
    setSearchText(value)
    const search = data.filter((item: any) => item?.value?.toLowerCase().match(value?.toLowerCase()))
    if (search.length) {
      setSearchData(search)
      return
    }
    setSearchData(data)
  }

  const dropdownList = () => {
    const isAllChecked = selectedData?.length > 0 && selectionData?.length === data?.length
    return (
      <Box {...styles.container} testID={'dropdown-wrapper'} onPress={onDismiss} nativeID="dropdown-wrapper">
        <Box
          {...styles.contentViewStyle}
          width={width}
          maxHeight={maxHeight}
          top={measureInfo.pageY + measureInfo.y}
          left={measureInfo.pageX - measureInfo.x}
          onPress={() => { }}
          underlayColor="WHITE"
          nativeID={testId}>
          <Box pv={8} ph={16} opacity={0.4}>
            <TextInput
              placeholder="Search"
              onChangeText={onChange}
              value={searchText}
              rightComponent={<Icon id="SEARCH" size="FONT_SIZE_MEDIUM" color="BLACK_75" />}
              color="BLACK_21"
              focusBorderColor="WHITE"
              fontSize={12}
            />
          </Box>
          <ModBox show={isMultiSelect && selectAll} ph={16} pv={8} flexDirection={'row'} gap={6} align={'center'}>
            <CheckBox
              color={isAllChecked ? checkboxColor : 'BLACK_LIGHT'}
              checked={isAllChecked}
              onChange={handleSelectAll}
              iconSize="FONT_SIZE_LARGE"
            />
            <Text color="BLACK_21" fontFamily={fontFamily} fontSize={'FONT_SIZE_SMALLER'} title={'Select All'} />
          </ModBox>
          <Box w={'100%'} h={1} bg="GREY_1_SEPARATOR" />
          <FlatList keyExtractor={getKeyExtractor} data={searchData} renderItem={renderItem} />
        </Box>
      </Box>
    )
  }

  return ReactDOM.createPortal(dropdownList(), document.body)
}

export { ModalView }
